import { createAsyncThunk } from '@reduxjs/toolkit';

export const createServiceAsyncThunkFactory = () => (typePrefix, asyncFn, thunkCustomError) =>
	createAsyncThunk(typePrefix, async (args, thunkAPI) => {
		try {
			return await asyncFn(args, thunkAPI);
		} catch (error) {
			const message =
				typeof thunkCustomError === 'function' ? thunkCustomError(error, args, thunkAPI)
				: typeof thunkCustomError === 'string' ? thunkCustomError
				: 'Something went wrong. Please try again.';

			return thunkAPI.rejectWithValue(message);
		}
	});
